//@ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import InputForm, { AutoCompleteValue } from "../../../Components/InputForm/InputForm";
import ButtonForm from "../../../Components/ButtonForm/ButtonForm";
import { APICall } from "../../../Helpers/Network/APICalls";
// import {} from "../../../Helpers/APIEndPoints/EndPoints";
import { useLocation } from "react-router-dom";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import { isDisabled } from "@testing-library/user-event/dist/utils";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import "./UnitCodeMaster.css";
import { CommonDropdownData, insertUpdateUnitCodeData, getUnitCodeDataById } from "../../../Helpers/APIEndPoints/EndPoints";
import { useSelector } from "react-redux";
import moment from "moment";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";

const UnitCodeMasterEdit = () => {
  const { state } = useLocation();
  let navigate = useNavigate();
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [unitName, setUnitName] = useState("");
  const [unitCode, setUnitCode] = useState("");
  const [oldUnitCode, setOldUnitCode] = useState("");
  const [company, setCompany] = useState({});
  const [companyOption, setCompanyOption] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [formDataOnEdit, setFormDataOnEdit] = useState<any>({});
  // submit validation
  const [formErrors, setFormErrors] = useState({});
  let formErrorObj = {};
  const context = useSelector((state: any) => state.updateReduxStore);

  useEffect(() => {
    (async () => {
      showLoader();
      getDropDownDataApiCall();
      setEditMode(true);
      if (state !== null && state.id && state.id > 0) {
        await getUnitCodeDataByIdF();
      }
      hideLoader();
    })();
  }, []);

  const getUnitCodeDataByIdF = async () => {
    let obj = {
      Id: state.id,
    };
    const resp = await APICall(getUnitCodeDataById, obj);
    if (resp?.Data?.Data?.length > 0) {
      setEditMode(false);
      setUnitName(resp.Data.Data[0].Name);
      setUnitCode(resp.Data.Data[0].Code);
      setOldUnitCode(resp.Data.Data[0].OldUnitCode);
      setIsActive(resp.Data.Data[0].IsActive);
      setFormDataOnEdit(resp.Data.Data[0]);
    }
  };

  const getDropDownDataApiCall = async () => {
    showLoader();
    let requestParams = {
      dropdownName: "companydd",
    };
    const res = await APICall(CommonDropdownData, requestParams);

    if (res && res.Data.length > 0) {
      let options = await res.Data;
      setCompanyOption(options);
      hideLoader();
    } else {
      setCompanyOption([]);
      notify(1, res.Message);
      hideLoader();
    }
  };

  useEffect(() => {
    if (companyOption.length > 0 && formDataOnEdit.CompanyId != "") {
      let val = companyOption.find((ele) => ele.value == formDataOnEdit.CompanyId);
      setCompany(val);
    }
  }, [companyOption, formDataOnEdit]);

  const selectOnChange = (event: any, apiFieldName: any) => {
    if (apiFieldName === "company") {
      setCompany(event);
    }
  };

  const onSubmitValidation = () => {
    setFormErrors({});
    formErrorObj = {};
    if (!unitName || unitName === "") {
      formErrorObj["UnitName_isEmpty"] = "Unit name can not be empty";
    }
    if (!unitCode || unitCode === "") {
      formErrorObj["UnitCode_isEmpty"] = "Unit code can not be empty";
    }
    if (!oldUnitCode || oldUnitCode === "") {
      formErrorObj["OldUnitCode_isEmpty"] = "Old unit code can not be empty";
    }
    if (!company || Object.keys(company).length <= 0) {
      formErrorObj["company_isEmpty"] = "Please select company";
    }
    setFormErrors(formErrorObj);
  };

  const onClickFunction = async (action: any) => {
    showLoader();
    if (action === "Submit") {
      await onSubmitValidation();
      let isEmpty = Object.values(formErrorObj).every((f) => {
        return f === "" || f === null || f === undefined;
      });
      if (isEmpty === true) {
        let param = {
          Id: state.id != null || state.id != 0 ? state.id : 0,
          Name: unitName,
          Code: unitCode,
          OldUnitCode: oldUnitCode,
          CompanyId: company.value,
          IsActive: isActive ? 1 : 0,
          CreatedBy: context.Id,
          CreatedDateUtc: moment(new Date()).format(moment.HTML5_FMT.DATETIME_LOCAL),
        };

        
        const insertData = await APICall(insertUpdateUnitCodeData, param);
        

        if (insertData?.Data?.Status == ApiStatus.Error) {
          const errors = insertData?.Data?.Data;
          const errorComponent = Array.isArray(errors) ? <div dangerouslySetInnerHTML={{ __html: errors?.join("<br />") }} /> : errors;
          notify(1, errorComponent);
        } else if (insertData?.Status == ApiStatus.Error) {
          notify(1, insertData?.Data);
        } else if (insertData?.Data != null) {
          if (state !== null && state.id && state.id > 0) {
            notify(0, "Unit code successfully updated");
          } else {
            notify(0, "Unit code successfully inserted");
          }
          navigate(-1);
        } else {
          notify(1, insertData?.Message);
        }

      
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      navigate(-1);
    }
    hideLoader();
  };

  const handleKeyNumbers = (event) => {
    // Prevent numeric character input
    const charCode = event.which || event.keyCode; // Handle cross-browser compatibility
    if (charCode >= 48 && charCode <= 57) {
      event.preventDefault();
    }
  };

  const handleTextEvent = async (event: any, field: any) => {
    // const regex = /^[0-9]+$/;
    let value = event.target.value;
    if (field === "unitName") {
      setUnitName(value);
    }
    if (field === "oldUnitCode") {
      // if (value === "" || regex.test(value)) {
      if (value.length > 10) {
        value = value.slice(0, 10);
      }
      setOldUnitCode(value);
      // }
    }
    if (field === "unitCode") {
      // if (value === "" || regex.test(value)) {
      if (value.length > 10) {
        value = value.slice(0, 10);
      }
      setUnitCode(value);
      // }
    }
  };

  const resetFunction = () => {
    setFormErrors({});
    formErrorObj = {};
    setUnitName("");
    setUnitCode("");
    setOldUnitCode("");
    setCompany({});
  };

  const handleKeyPress = (event) => {
    if (event.key === "-" || event.key === "e" || event.key === "E") {
      event.preventDefault();
    }
  };

  return (
    <>
      <div>
        <div className="">
          <div className="col-lg-12 col-md-12 p-0">
            <div className="row">
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Unit Name</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  // disabled={editMode ? true : false}
                  placeholder={""}
                  value={unitName}
                  onChange={(e) => handleTextEvent(e, "unitName")}
                  textArea={false}
                  onKeyPress={handleKeyNumbers}
                />
                <p style={{ color: "red" }}>{formErrors["UnitName_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Old Unit Code</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  // disabled={editMode ? true : false}
                  placeholder={""}
                  value={oldUnitCode}
                  onChange={(e) => handleTextEvent(e, "oldUnitCode")}
                  // onKeyPress={(e) => handleKeyPress(e)}
                  textArea={false}
                />
                <p style={{ color: "red" }}>{formErrors["OldUnitCode_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Payroll Area</label>
                {/* <label>New Unit Code</label> */}
                <sup style={{ fontSize: "13px" }}>*</sup>
                <InputForm
                  // disabled={editMode ? true : false}
                  placeholder={""}
                  value={unitCode}
                  onChange={(e) => handleTextEvent(e, "unitCode")}
                  // onKeyPress={(e) => handleKeyPress(e)}
                  textArea={false}
                />
                <p style={{ color: "red" }}>{formErrors["UnitCode_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
                <div className="form-group"></div>
                <label>Company</label>
                <sup style={{ fontSize: "13px" }}>*</sup>
                <SelectForm options={companyOption} isMulti={false} placeholder={""} value={company} onChange={(event: any) => selectOnChange(event, "company")} />
                <p style={{ color: "red" }}>{formErrors["company_isEmpty"]}</p>
              </div>
              <div className="col-lg-3 col-sm-3 col-xs-3 ">
              <div className="form-group"></div>
                <div className="form-group">
                  <label className="col-form-label">Active Status</label>
                  <sup>*</sup>
                  <div className="custom-checkbox">
                    <input
                      autoComplete={AutoCompleteValue}
                      disabled={editMode ? true : false}
                      type="checkbox"
                      onChange={(e) => setIsActive(e.target.checked)}
                      name="isActive"
                      checked={isActive}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-3">
          <div>
            <ButtonForm className="btn btn-submit" style={{ marginLeft: 5 }} id="submit" value={<p><i className="fas fa-paper-plane"></i> Submit</p> }  onClick={() => onClickFunction("Submit")} />
          </div>
          {state !== null && state.id && state.id > 0 ? (
            ""
          ) : (
            <div>
              <ButtonForm className="btn btn-info" id="Reset" style={{ marginLeft: 5 }} value={<p><i className="fas fa-undo"></i> Reset</p> } onClick={() => onClickFunction("Reset")} />
            </div>
          )}
          <div>
            <ButtonForm className="btn btn-cancel" id="cancel" style={{ marginLeft: 5 }} value={<p><i className="far fa-times-circle"></i> Cancel</p> } onClick={() => navigate("/master/UnitCodeMaster")} />
          </div>
        </div>
      </div>
    </>
  );
};

export default UnitCodeMasterEdit;
